(function(angular){
    'use strict';

    angular.module('core').directive('urlValidator', [function(){
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function(scope, element, attr, ngModel){
                    ngModel.$validators.invalidUrl = function(value) {
                        // optional
                        if(angular.isUndefined(value) || value === ''){
                            return true;
                        }

                        var urlRegex = /^(https?:\/\/)([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
                        return urlRegex.test(value);
                    };
                }
            };
        }]
    );
})(window.angular);
